import {
  muteRadio,
  pauseRadio,
  playRadio,
  unmuteRadio,
  radioMarqueeAnimationSubscribe,
  radioMuteToggleSubscribe,
  radioPauseSubscribe,
  radioPlaySubscribe,
  publishRadioState,
  loginSub,
} from './workflows';
import { readFromLocalStorage, removeFromLocalStorage, writeToLocalStorage } from './localStorageHandlers';
import { publish } from '@wh/message-bus';

const createState = ({
  animationOn = false,
  id = '',
  marqueeText = '',
  muted = false,
  playing = false,
  playingLabel = '',
} = {}) => ({
  animationOn,
  id,
  marqueeText,
  muted,
  playing,
  playingLabel,
});

const state = createState();
let isLogged;

const setState = ({ newState = {}, publishState = true }) => {
  if (publishState) {
    publishRadioState(newState);
  }
  Object.assign(state, newState);

  return newState;
};

const onMarqueeAnimationStart = (stateData) => () => {
  const newState = createState({ ...stateData, animationOn: true });
  setState({ newState, publishState: false });

  return newState;
};

const onMuteToggle = (stateData) => () => {
  const newState = createState({ ...stateData, muted: !stateData.muted });

  if (newState.muted) {
    muteRadio();
  } else {
    unmuteRadio();
  }

  setState({ newState });
  writeToLocalStorage(newState);

  return newState;
};

const onPauseClicked = () => {
  const newState = createState();

  pauseRadio();
  setState({ newState });
  removeFromLocalStorage();

  return newState;
};

const onPlayClicked = ({ data }) => {
  const { id, label, marqueeText } = data;
  const newState = createState({ id, marqueeText, playing: true, playingLabel: label });

  if (isLogged) {
    playRadio(id);
    setState({ newState });
  } else {
    publish('wh.common.command.ui.login.flow.start');
  }

  writeToLocalStorage(newState);

  return newState;
};

const afterInitRadio = (stateData, data) => {
  if (data && isLogged) {
    const newState = createState({ ...stateData, ...data, animationOn: false });

    setState({ newState });

    return newState;
  }

  return {};
};

const loginFunc = ({ data }) => {
  isLogged = data?.isLoggedIn;
  const dataFromLocalStorage = readFromLocalStorage();
  if (isLogged && dataFromLocalStorage) {
    afterInitRadio(state, dataFromLocalStorage);
    playRadio(dataFromLocalStorage.id);
  }
};

export const initRadio = () => {
  const data = readFromLocalStorage();

  loginSub(loginFunc);
  radioMarqueeAnimationSubscribe(onMarqueeAnimationStart(state));
  radioMuteToggleSubscribe(onMuteToggle(state));
  radioPlaySubscribe(onPlayClicked);
  radioPauseSubscribe(onPauseClicked);
  afterInitRadio(state, data);
};
